module.exports = __webpack_public_path__ + "static/media/logo-cpservice.60b001c6.png";